import React, { useState, useContext } from 'react';
import { TextareaAutosize, Button } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContextProvider';
import DragAndDropTarget from '../DragAndDropTarget';

import '../App.css';

const UploadPhotos = () => {
  const [files, setFiles] = useState([]);
  const [fileNames, setFileNames] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleFileUpload = (files) => {
    if (files.length === 0) {
      setErrorMessage('Please select files to upload');
      setOpenErrorDialog(true);
      return;
    }
    const fileNames = [];
    files.forEach(file => {
      if (!file.name.endsWith('.jpg') && !file.name.endsWith('.jpeg') && !file.name.endsWith('.gif')) {
        setErrorMessage('Only .jpg/.jpeg/.gif files are allowed');
        setOpenErrorDialog(true);
        return;
      }
      fileNames.push(file.name);
    });
    setFileNames(fileNames.join(', '));
    setFiles(files);
  };
  
  const uploadPhotos = async () => {
    if (files.length === 0) {
      setErrorMessage('Please fill in all fields');
      setOpenErrorDialog(true);
      return;
    }
    try {
      const params = new FormData();
      files.forEach(file => {
        params.append(file.name, file);
      });
      let url = `/itvs-site/upload?site=${user._site._id}`;
      if (user.caringFor) {
        url += `&forMember=${user.caringFor._id}`;
      }
      await fetch(url, {
        method: "post",
        body: params,
      });
      navigate("/photos");
    } catch (err) {
      console.error(err);
      setErrorMessage(`upload photos failed: ${err}`);
      setOpenErrorDialog(true);
    }
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  return (
    <div className="UploadPhotos">
      <DragAndDropTarget onFileUpload={handleFileUpload} 
        message="Drag and drop .jpeg, .jpg or .gif photo files here or click to select them"
      />
      <TextareaAutosize
        className="TextareaAutosize"
        aria-label="Files"
        minRows={3}
        value={fileNames}
        disabled={true}
      />
      <Button className="Button" variant="contained" color="primary" onClick={uploadPhotos}>
        Save
      </Button>
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default UploadPhotos;